
module.exports = { 
      attributes: {},
    
      body: "Child, youth, and family health services support families by offering services like:\n\n- Counselling and parenting to develop positive parenting skills that strengthens family relationships\n- Hearing checks for children\n- Parenting classes\n- School-based youth health\n- Speech support\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/child-youth-and-family-health.md"},
     }